// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"219":"91c347c0","918":"41a58730"}[chunkId] + ".chunk.css";
};